import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { environment } from '@accedo/xdk-core';
import { vKey } from '@accedo/xdk-virtual-key';
import { getPrivacyPolicy } from '#/redux/modules/accedoOne/selectors';
import { requestPrivacyPolicy } from '#/redux/modules/accedoOne/actions';
import { privacyPolicyTitle } from '#/config/strings';
import contentModalStyles from '#/widgets/modals/common/ContentModal/ContentModal.scss';

const { UP, DOWN } = vKey;
const SCROLL_STEP = 20;

const onScroll = (target, direction = 1) => {
  target.scrollBy(0, direction * SCROLL_STEP);
};

const PrivacyAgreementModal = () => {
  const dispatch = useDispatch();
  const content = useSelector(getPrivacyPolicy);
  const contentAreaRef = useRef(null);

  const handleScroll = useCallback(({ id }) => {
    if (!contentAreaRef.current) {
      return;
    }

    switch (id) {
      case UP.id:
        onScroll(contentAreaRef.current, -1);
        return false;

      case DOWN.id:
        onScroll(contentAreaRef.current, 1);
        return false;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (!content) {
      dispatch(requestPrivacyPolicy);
    }
    contentAreaRef?.current?.focus();
  }, []);

  useEffect(() => {
    environment.addEventListener(environment.SYSTEM.KEYDOWN, handleScroll);
    return () => {
      environment.removeEventListener(environment.SYSTEM.KEYDOWN, handleScroll);
    };
  });

  return (
    <>
      <h2 className={contentModalStyles.title}>{privacyPolicyTitle}</h2>
      <p
        ref={contentAreaRef}
        tabIndex={0}
        className={contentModalStyles.textContent}
      >
        {content}
      </p>
    </>
  );
};

export default PrivacyAgreementModal;
